import { Injectable } from '@angular/core';
import { MonitoringService } from './monitoring.service';
import {
  AuthLoginFailedPayload,
  AuthObservabilityEvents,
} from './models/auth-observability.model';

@Injectable({
  providedIn: 'root',
})
export class AuthObservabilityService {
  constructor(private readonly monitoring: MonitoringService) {}

  trackLoginSucceeded(): void {
    this.monitoring.trackEvent(AuthObservabilityEvents.LOGIN_SUCCEEDED);
  }

  trackLoginFailed(payload: AuthLoginFailedPayload): void {
    this.monitoring.trackEvent(AuthObservabilityEvents.LOGIN_FAILED, {
      errorCode: payload.errorCode,
    });
  }

  trackLogout(): void {
    this.monitoring.trackEvent(AuthObservabilityEvents.LOGOUT);
  }

  trackAccessDenied(): void {
    this.monitoring.trackEvent(AuthObservabilityEvents.ACCESS_DENIED);
  }
}
